import moment from 'moment-timezone';
import React from 'react'
import { Table } from 'reactstrap'

const LogsTable = ({ logs }) => {
    // const formattedDate = moment(timeZone).format('MMMM DD YYYY, hh:mm A');
    const renderTableHeader = React.useCallback(() => {

        return (
            <tr>
                <th className="col-1">
                    <span>Date</span>
                </th>
                <th className="col-1">
                    Time
                </th>
                <th className="col-3">
                    Event
                </th>
                <th className="col-2">
                    User
                </th>
                <th className="col-5">
                    Notes
                </th>
            </tr>
        )
    }, [])


    const renderTableContent = React.useCallback((item) => {
        return (
            <LogItem item={item} key={item?.id} />
        )
    }, []);

    return (
        <div className='table_responsive'>
            <table className="table">
                <thead className="text-primary">
                    {renderTableHeader()}
                </thead>
                <tbody>
                    {
                        logs && logs?.map(item => renderTableContent(item))
                    }
                </tbody>
            </table>
        </div>
    )
}

const getLocalDateTime = (item) => {
    if (item?.created_at) {
        return moment.utc(item.created_at).tz("America/Los_Angeles");
    }
    if (item?.date && item?.time) {
        return moment.utc(`${item.date} ${item.time}`, "YYYY-MM-DD hh:mm a").tz("America/Los_Angeles");
    }
    return null;
};

const LogItem = ({ item }) => {
    const localTime = getLocalDateTime(item);
    const formattedDate = localTime ? localTime.format("MMM D, YYYY") : (item?.date ? moment(item.date).format("MMM D, YYYY") : "");
    const formattedTime = localTime ? localTime.format("hh:mm A") : (item?.time || "");

    return (

        <tr>
            <td className='col-2'>
                {formattedDate}
            </td>
            <td className='col-2'>
                {formattedTime}
            </td>
            <td className='col-2'>
                {item?.event}
            </td>
            <td className='col-2'>
                {item?.user?.name}
            </td>
            <td className='col-4'>
                {item?.notes}
            </td>
        </tr>
    )
}
export default LogsTable